module.exports = __webpack_public_path__ + "img/bg-redeem-vip.511a868c.png";